const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
})

export default styles
